import { render } from "./addtag.vue?vue&type=template&id=13172f44&scoped=true"
import script from "./addtag.vue?vue&type=script&lang=js"
export * from "./addtag.vue?vue&type=script&lang=js"

import "./addtag.vue?vue&type=style&index=0&id=13172f44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13172f44"]])

export default __exports__